<template>
  <div class="card">
    <!-- <div class="card-header"></div> -->
    <div class="card-body">
      <vue-tabs v-model="dselTab" direction="horizontal" @tab-change="getTabData">
        <v-tab :title="rd.value" v-for="(rd, index) in rawDataList" v-bind:key="index">
          <!-- <Issues
            :rawDataType="rawDataType"
            :comp="company"
            :tableFields="tableFields"
            :rows="tableRows"
            :issuesData="rawData"
          />-->
          <div class="row mb5 mt15">
            <div class="col-md-10"></div>
            <div class="col-md-2" v-if="rawData.length>0">
              <download :tableId="rawDataType" :fileName="rawDataType"></download>
            </div>
          </div>
          <div class="table-responsive app" v-dragscroll="true">
            <table :id="rawDataType" class="table table-bordered fonts11 app-inner">
              <thead v-if="rawData.length>0">
                <tr>
                  <th>Sr.</th>
                  <th
                    v-for="(tc, index) in tableFields"
                    v-bind:key="index+'tc'+tc.title"
                  >{{tc.name}}</th>
                </tr>
              </thead>
              <tbody v-if="rawData.length>0">
                <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                  <td>{{ind+1}}</td>
                  <td v-for="(cl, index) in tableFields" v-bind:key="index+'cldata'+cl.title">
                    <!-- {{cl.orgKey}}{{[cl.title]}}{{[ind]}} {{tr[cl.title]}} -->
                    <span
                      v-if="cl.title==='OPENDATE' || cl.title==='CLOSDATE'"
                    >{{(tr[cl.title])? getDateTime(tr[cl.title]): '-'}}</span>
                    <span
                      v-else-if="cl.title==='Date'"
                    >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                    <span v-else-if="cl.type && cl.type==='boolean'">{{(tr[cl.title])? 'Yes': 'No'}}</span>
                    <span
                      v-else-if="cl.type && cl.type==='date'"
                    >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                    <span
                      v-else-if="cl.type && cl.type==='datetime'"
                    >{{(tr[cl.title])? getDateTime(tr[cl.title]): '-'}}</span>
                    <span v-else>{{(tr[cl.title])? tr[cl.title]: '-'}}</span>
                  </td>
                </tr>
              </tbody>
              <tr v-if="rawData.length===0">
                <td>
                  <div class="alert alert-danger" role="alert">No data found!</div>
                </td>
              </tr>
            </table>
          </div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";

import http from "@/lib/http";

import { commonMixins } from "../../../assets/mixins/common.js";
import { rawMixins } from "../../../assets/mixins/rawMixins.js";

// import Issues from "@/views/tableFields/rawData/issues";

export default {
  // props: ["issuesData", "comp", "rawDataType", "tableFields", "rows"],
  mixins: [commonMixins, rawMixins],
  components: { VueTabs, VTab },
  created() {
    if (!localStorage.getItem("drawtab")) {
      this.rawDataType = this.rawDataList[this.selRowInd].id;
      // this.dselTab = this.rawDataList[this.selRowInd].value;
      localStorage.setItem("drawtab", this.rawDataType);
      localStorage.setItem("dselTab", this.dselTab);
      this.getRawData();
    } else {
      this.rawDataType = localStorage.getItem("drawtab");
      if (localStorage.getItem("dselTab") !== "instrument_name") {
        this.dselTab = localStorage.getItem("dselTab");
      } else {
        this.getRawData();
      }
    }
  },
  methods: {
    getRawData() {
      this.rawData = [];
      this.tableFields = [];
      (this.companies = []),
        (this.selectedCompanies = []),
        (this.isCompSel = true),
        (this.isCompared = false);
      let myself = this;
      http.post(
        this.rawDataApi,
        { rowFieldName: this.rawDataType, co_code: 0 },
        (error, response) => {
          // console.log("Response", response.data);

          if (this.rawDataType === "sectors") {
            this.rawData = response.data.splice(1);
          } else {
            this.rawData = response.data;
          }
          this.setTableValues();
          console.log("this.rawData", this.rawData);
          this.rawDataList[this.selRowInd].items = this.rawData;
          //TODO:: add tableFields updates into our array in future
        }
      );
    },
    setTableValues() {
      this.downLoadableData = [];
      this.tableFields = [];
      console.log(this.rawDataType);
      if (this.rawDataType === "instrument_name") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: "",
                sort_order:
                    val === "InstName"
                    ? 1:99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "instrument_symbol") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: "",
                sort_order:
                    val === "InstName"
                    ? 1
                    : val === "symbol"
                    ? 2
                    :99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        this.rawData = this.sorted_fields_date(this.rawData, "xdate");
        console.log(this.tableRows, this.tableFields, this.rawData);
      } else if (this.rawDataType === "instrument_expiry_date") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: (val==='ExpDate')? 'date':"",
                sort_order:
                    val === "InstName"
                    ? 1
                    : val === "symbol"
                    ? 2
                    : val === "ExpDate"
                    ? 3
                    :99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        this.rawData = this.sorted_fields_date(this.rawData, "ExpDate");
        console.log(this.tableRows, this.tableFields, this.rawData);
      } else if (this.rawDataType === "instrument_option_type") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: (val==='ExpDate')? 'date':"",
                sort_order:
                    val === "InstName"
                    ? 1
                    : val === "symbol"
                    ? 2
                    : val === "opttype"
                    ? 3
                    : val === "opttype"
                    ? 4
                    :99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_NiftyFutures") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "ExpDate" ? "date" : "",
                sort_order:
                   val === "InstName"
                    ? 1
                    : val === "symbol"
                    ? 2
                    : val === "ExpDate"
                    ? 3
                    : val === "opttype"
                    ? 4
                    : val === "StrikePrice"
                    ? 5
                    : val === "LTP"
                    ? 6
                    : val === "TradedQty"
                    ? 7
                    : val === "TurnOver"
                    ? 8
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "ExpDate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "derivatives_top_traded_quantity" || this.rawDataType === "derivatives_top_traded_value") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "ExpDate" ? "date" : "",
                sort_order:
                  val === "InstName"
                    ? 1
                    : val === "symbol"
                    ? 2
                    : val === "ExpDate"
                    ? 3
                    : val === "OptType"
                    ? 4
                    : val === "opt_input"
                    ? 5
                    : val === "StrikePrice"
                    ? 6
                    : val === "LTP"
                    ? 7
                    : val === "TradedQty"
                    ? 8
                    : val === "TurnOver"
                    ? 9
                    : val === "FAODiff"
                    ? 10
                    : val === "OI"
                    ? 11
                    : val === "Qty"
                    ? 12
                    : val === "Value"
                    ? 13
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "derivatives_summary") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "ExpDate" ? "date" : "",
                sort_order:
                  val === "InstName"
                    ? 1
                    : val === "symbol"
                    ? 2
                    : val === "ExpDate"
                    ? 3
                    : val === "OptType"
                    ? 4
                    : val === "opt_input"
                    ? 5
                    : val === "StrikePrice"
                    ? 6
                    : val === "LTP"
                    ? 7
                    : val === "TradedQty"
                    ? 8
                    : val === "TurnOver"
                    ? 9
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_FIIStatistics") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "holidaydate" ? "date" : "",
                sort_order: val === "Details" 
                ? 1 
                : val === "Buy_NoOfContracts" 
                ? 2 
                : val === "Buy_Value" 
                ? 3 
                : val === "Sell_NoOfContracts" 
                ? 4 
                : val === "Sell_Value" 
                ? 5 
                : val === "NetBuySellValue" 
                ? 6 
                : val === "OI_NoOfContracts" 
                ? 7 
                : val === "OI_Value" 
                ? 8 
                : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_DailySettlementPrices") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "Maturity_Date"?  "date" : val === "UPDDate" ? "date": "",
                sort_order:
                  val === "Instrument"
                    ? 1
                    : val === "Underlying"
                    ? 2
                    : val === "Maturity_Date"
                    ? 3
                    : val === "Stlmnt_Price"
                    ? 4
                    : val === "UPDDate"
                    ? 5
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "StartDate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_ListOfUnderlying") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "UPDDate" ? "date": "",
                sort_order:
                  val === "Symbol"
                    ? 0
                    : val === "TradedQty"
                    ? 1
                    : val === "TurnOver"
                    ? 2
                    : val === "UpdTime"
                    ? 3
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "StartDate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_PutCallRatio") {
        this.tableRows = [];
        this.tableFields = [];
         if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "Date" || val === "expdate" ? "date": "",
                sort_order:
                  val === "Symbol"
                    ? 0
                    : val === "PutOI"
                    ? 1
                    : val === "CallOI"
                    ? 2
                    : val === "TotOI"
                    ? 3
                    : val === "PCRatioOI"
                    ? 4
                    : val === "PutQty"
                    ? 5
                    : val === "CallQty"
                    ? 6
                    : val === "TotQty"
                    ? 7
                    : val === "PCRatioQty"
                    ? 8
                    : val === "expdate"
                    ? 9
                    : val === "Date"
                    ? 10
                    : 99
              });
            }
          });
          console.log(this.tableRows, this.tableFields);
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "StartDate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_CostOfCarry") {
        this.tableRows = [];
        this.tableFields = [];
         if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "FARDATE" || val === "expdate" ? "date": "",
                sort_order:
                  val === "SYMBOL"
                    ? 0
                    : val === "CLOSEPRICE"
                    ? 1
                    : val === "ltp"
                    ? 2
                    : val === "FARDATE"
                    ? 3
                    : val === "COC"
                    ? 4
                    : val === "openinterest"
                    ? 5
                    : val === "chg"
                    ? 6
                    : val === "expdate"
                    ? 7
                    : 99
              });
            }
          });
          console.log(this.tableRows, this.tableFields);
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "expdate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_PositionLimit") {
        this.tableRows = [];
        this.tableFields = [];
         if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: "",
                sort_order:
                  val === "Symbol"
                    ? 0
                    : val === "OI"
                    ? 1
                    : val === "MWPL"
                    ? 2
                    : val === "MWPLChg"
                    ? 3
                    : 99
              });
            }
          });
          console.log(this.tableRows, this.tableFields);
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_RollOver") {
        this.tableRows = [];
        this.tableFields = [];
         if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "Updtime" || val === "expdate" ? "date": "",
                sort_order:
                  val === "Symbol"
                    ? 0
                    : val === "BaseOI"
                    ? 1
                    : val === "CurrentOI"
                    ? 2
                    : val === "CurrentChgOI"
                    ? 3
                    : val === "NextOI"
                    ? 4
                    : val === "NextOIChg"
                    ? 5
                    : val === "TodayRollOver"
                    ? 6
                    : val === "LastRollOver"
                    ? 8
                    : val === "TotalRollOver"
                    ? 9
                    : val === "RollOver"
                    ? 10
                    : 99
              });
            }
          });
          console.log(this.tableRows, this.tableFields);
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "expdate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_ImpliedVolatility") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "Updtime" || val === "ExpDate" ? "date": "",
                sort_order:
                  val === "Symbol"
                    ? 0
                    : val === "optType"
                    ? 1
                    : val === "OptPrice"
                    ? 2
                    : val === "underly"
                    ? 3
                    : val === "strikeprice"
                    ? 4
                    : val === "IV"
                    ? 5
                    : val === "ExpDate"
                    ? 6
                    : 99
              });
            }
          });
          console.log(this.tableRows, this.tableFields);
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "ExpDate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_MostActiveContracts") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "Updtime" || val === "ExpDate" ? "date": "",
                sort_order:
                  val === "symbol"
                    ? 0
                    : val === "InstName"
                    ? 1
                    : val === "OpenInterest"
                    ? 2
                    : val === "TradedQty"
                    ? 3
                    : val === "TradedValue"
                    ? 4
                    : val === "ExpDate"
                    ? 5
                    : 99
              });
            }
          });
          console.log(this.tableRows, this.tableFields);
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "ExpDate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_AllIndexFuture") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "Updtime" || val === "ExpDate" ? "date": "",
                sort_order:
                  val === "symbol"
                    ? 0
                    : val === "InstName"
                    ? 1
                    : val === "LTP"
                    ? 2
                    : val === "TradedQty"
                    ? 3
                    : val === "strikeprice"
                    ? 4
                    : val === "IV"
                    ? 5
                    : val === "TurnOver"
                    ? 6
                    : val === "HighPrice"
                    ? 7
                    : val === "LowPrice"
                    ? 8
                    : val === "OpenPrice"
                    ? 9
                    : val === "ClosePrice"
                    ? 10
                    : val === "PreviousClose"
                    ? 11
                    : val === "OpenInterest"
                    ? 12
                    : val === "PercentChange_OpenInterest"
                    ? 13
                    : 99
              });
            }
          });
          console.log(this.tableRows, this.tableFields);
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "ExpDate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_MostActive_put" || this.rawDataType === "Derivatives_MostActive_call") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "Updtime" || val === "ExpDate" ? "date": "",
                sort_order:
                  val === "symbol"
                    ? 0
                    : val === "InstName"
                    ? 1
                    : val === "OptType"
                    ? 2
                    : val === "StrikePrice"
                    ? 3
                    : val === "ClosePrice"
                    ? 4
                    : 99
              });
            }
          });
          console.log(this.tableRows, this.tableFields);
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "ExpDate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "MarketReport_FUT" || this.rawDataType === "MarketReport_OPT") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "Updtime" || val === "ExpDate" ? "date": "",
                sort_order:
                  val === "symbol"
                    ? 0
                    : val === "InstName"
                    ? 1
                    : val === "opt_input"
                    ? 2
                    : val === "LTP"
                    ? 3
                    : val === "FaoChange"
                    ? 4
                    : val === "OpenInterest"
                    ? 5
                    : val === "ChgOpenInt"
                    ? 6
                    : val === "ExpDate"
                    ? 7
                    : 99
              });
            }
          });
          console.log(this.tableRows, this.tableFields);
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "ExpDate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "NSEFAO_AdvDec") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "Updtime" || val === "ExpDate" ? "date": "",
                sort_order:
                  val === "type"
                    ? 0
                    : val === "advance"
                    ? 1
                    : val === "decline"
                    ? 2
                    : val === "unchanged"
                    ? 3
                    : val === "total"
                    ? 4
                    : 99
              });
            }
          });
          console.log(this.tableRows, this.tableFields);
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "ExpDate");
        }
        console.log(this.tableRows, this.tableFields);
      } else if (this.rawDataType === "Derivatives_ListOfUnderlying") {
        this.tableRows = [];
        this.tableFields = [];
        if (this.rawData.length > 0) {
          var rowKeys = Object.keys(this.rawData[0]);
          rowKeys.forEach((val, key) => {
            console.log("Rows", key, val);
            if (val !== "sno" && val !== "_id" && val !== "BSECODE") {
              this.tableFields.push({
                title: val,
                name: this.getCustomLabel(val)
                  ? this.getCustomLabel(val)
                  : this.getLabel(val),
                type: val === "UPDDate" ? "date": "",
                sort_order:
                  val === "Symbol"
                    ? 0
                    : val === "TradedQty"
                    ? 1
                    : val === "TurnOver"
                    ? 2
                    : val === "UpdTime"
                    ? 3
                    : 99
              });
            }
          });
          this.tableFields = this.sorted_fields_asc(
            this.tableFields,
            "sort_order"
          );
          this.rawData = this.sorted_fields_date(this.rawData, "StartDate");
        }
        console.log(this.tableRows, this.tableFields);
      } 
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log(
        "TabChange",
        this.dselTab,
        oldTab.title,
        this.dselTab === oldTab.title,
        tabIndex,
        newTab,
        oldTab
      );
      if (this.dselTab !== oldTab.title) {
        this.rawDataList[this.selRowInd].open = false;
        this.selRowInd = tabIndex;
        this.rawDataList[tabIndex].open = !this.rawDataList[tabIndex].open;
        this.rawDataType = this.rawDataList[tabIndex].id;
        this.dselTab = this.rawDataList[tabIndex].value;
        localStorage.setItem("drawtab", this.rawDataList[tabIndex].id);
        localStorage.setItem("dselTab", this.rawDataList[tabIndex].value);
        this.getRawData();
      } else if (this.dselTab === oldTab.title) {
        this.selRowInd = tabIndex;
        this.rawDataList[tabIndex].open = !this.rawDataList[tabIndex].open;
      }
    }
  },
  data() {
    return {
      company: { co_code: 0, companyname: "" },
      rawDataList: [
        { id: "instrument_name", value: "Instrument Name", items: {} },
        { id: "instrument_symbol", value: "Instrument Symbol", items: {} },
        { id: "instrument_expiry_date", value: "Instrument Expiry Date", items: {} },
        { id: "instrument_option_type", value: "Instrument Option Type", items: {} },
        { id: "Derivatives_NiftyFutures", value: "NIFTY Futures", items: {} },
        { id: "derivatives_top_traded_quantity", value: "Top Traded Quantity", items: {} },
        { id: "derivatives_top_traded_value", value: "Top Traded Value", items: {} },
        { id: "derivatives_summary", value: "Summary", items: {} },
        { id: "Derivatives_FIIStatistics", value: "FII Statistics", items: {} },
        { id: "Derivatives_DailySettlementPrices", value: "Daily Settlement Prices", items: {} },
        { id: "Derivatives_ListOfUnderlying", value: "List of Underlying", items: {} },
        { id: "Derivatives_PutCallRatio", value: "Put Call Ratio", items: {} },
        { id: "Derivatives_CostOfCarry", value: "Cost of Carry", items: {} },
        { id: "Derivatives_PositionLimit", value: "Position Limit", items: {} },
        { id: "Derivatives_RollOver", value: "Rollover", items: {} },
        { id: "Derivatives_ImpliedVolatility", value: "Implied Volatility", items: {} },
        { id: "Derivatives_MostActiveContracts", value: "Most Active Contracts", items: {} },
        { id: "Derivatives_AllIndexFuture", value: "All Index Future", items: {} },
        { id: "Derivatives_MostActive_put", value: "Most Active Put", items: {} },
        { id: "Derivatives_MostActive_call", value: "Most Active Call", items: {} },
        { id: "MarketReport_FUT", value: "Market Report FUT", items: {} },
        { id: "MarketReport_OPT", value: "Market Report OPT", items: {} },
        { id: "NSEFAO_AdvDec", value: "NSE Future & Option Advance/Declined/Unchanged", items: {} },
        // { id: "name_change", value: "Name Changes", items: {} },
        
      ],
      rawDataType: "sectors",
      rawDataApi: "rawDataList",
      selRowInd: 0,
      dselTab: "",
      tableFields: [],
      tableRows: [],
      rawData: []
    };
  },
  watch: {
    issuesData: function(value) {
      console.log(this.issuesData, value);
      this.rawData = value;
    }
  },
  computed: {
    mfHoldingData: function() {
      return this.rawData.filter(function(row, index) {
        return index !== "_id" && index !== "co_code";
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/company/rawdata/derivatives.vue